import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import format from 'date-fns/format'

import { AppContext } from '../../App'
import Loader from '../../components-utils/Loader'
import DateRange, { FORMATDATE } from '../../components-utils/DateRange'

import { getPeriod, savePeriod } from '../../services/api'
import { loadItem } from '../../services/utils'
import { validateObject, mandatory } from '../../services/validator'
import { constructError } from '../../services/errors.js'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'

import './Period.css'

const emptyPeriod = merchantCode => ({
  id: -1,
  merchantCode: merchantCode,
  technicalLabel: '',
  ranges: []
})

class Period extends Component {
  state = {
    errors: {}
  }

  async componentDidMount() {
    const result = await loadItem(this.props, getPeriod, emptyPeriod)
    if (result !== undefined) {
      this.setState({
        period: result.item,
        merchantCode: result.merchantCode
      })
    }
  }

  changeFields = name => e => {
    const val = e.target.value
    this.setState(state => ({
      period: {
        ...state.period,
        [name]: val
      }
    }))
  }

  changeDate = (name, index, newDate) => {
    this.setState(state => ({
      period: {
        ...state.period,
        ranges: state.period.ranges.map(
          (range, i) =>
            i === index
              ? {
                  ...range,
                  [name]: format(newDate, FORMATDATE)
                }
              : range
        )
      }
    }))
  }

  labelValidators = {
    technicalLabel: [mandatory]
  }
  savePeriod = () => {
    const errors = validateObject(this.state.period, this.labelValidators)
    this.setState({ errors }, () => {
      const { errors, period, merchantCode } = this.state
      if (errors === undefined) {
        const {
          snackbar,
          history,
          match: {
            params: { id }
          }
        } = this.props
        if (merchantCode !== undefined) {
          savePeriod(id, merchantCode, period)
            .then(period => {
              this.setState({ period }, () => {
                history.push(`/periods/${period.id}`)
                snackbar('Informations enregistrées')
              })
            })
            .catch(e => {
              console.log(e)
              snackbar(
                'Erreur pendant la sauvegarde de la catégorie. Veuillez réessayer',
                'error'
              )
            })
        }
      }
    })
  }

  addRange = newRange => {
    this.setState(state => ({
      period: {
        ...state.period,
        ranges: [...state.period.ranges, newRange]
      }
    }))
  }

  deleteRange = index => {
    this.setState(state => ({
      period: {
        ...state.period,
        ranges: state.period.ranges.filter((range, i) => i !== index)
      }
    }))
  }

  renderLoader() {
    return <Loader loading={true} />
  }

  renderLabel() {
    const { period, errors } = this.state
    const errorLabel = errors && errors['technicalLabel']
    return (
      <FormControl margin="normal" fullWidth error={errorLabel !== undefined}>
        <InputLabel htmlFor="label">Libellé</InputLabel>
        <Input
          value={period.technicalLabel}
          onChange={this.changeFields('technicalLabel')}
        />
        <FormHelperText>
          {errorLabel && constructError(errorLabel)}
        </FormHelperText>
      </FormControl>
    )
  }

  renderDates() {
    const {
      period,
      period: { ranges }
    } = this.state
    return (
      <DateRange
        ranges={ranges}
        changeDate={this.changeDate}
        addRange={this.addRange}
        deleteRange={this.deleteRange}
        nameId="periodId"
        elementId={period.id}
      />
    )
  }

  render() {
    const { period } = this.state
    return period !== undefined ? (
      <Card key="page">
        <CardContent>
          <Typography variant="h4">
            {period.technicalLabel !== ''
              ? period.technicalLabel
              : 'Nouvelle Période'}
          </Typography>
          {this.renderLabel()}
          <Typography variant="h5" className="sp-period--subtitle">
            Plages de dates
          </Typography>
          {this.renderDates()}
        </CardContent>
        <CardActions className="sp-period--actions">
          <Button
            variant="contained"
            color="secondary"
            onClick={this.savePeriod}
          >
            Valider
          </Button>
        </CardActions>
      </Card>
    ) : (
      this.renderLoader()
    )
  }
}

const enhanced = WrappedComponent => props => {
  return (
    <AppContext.Consumer>
      {app => <WrappedComponent {...props} snackbar={app.snackbar.open} />}
    </AppContext.Consumer>
  )
}

export default withRouter(enhanced(Period))



// WEBPACK FOOTER //
// ./src/components/periods/Period.js